import React from 'react';
import {Swiper as SwiperType} from 'swiper/types';

import createCtx from 'coreUtils/createCtx';

import {ICarouselProps} from '../../ICarousel';

export const [useCarouselControllerContext, CarouselControllerContextProvider] = createCtx<{
	isInCarousel: boolean;
	controllerConfig?: ICarouselProps['config'] | null;
	liftSliderInstance?: (sliderInstance: SwiperType) => void;
	swiperRef?: React.RefObject<SwiperType | null>
}>();
